import React, { FC, HTMLAttributes } from 'react';
import Icon from '@/components/UI/icon/Icon';
import { BadgeSize, BadgeTypes, IconNames } from '@/components/UI/Types';
import styles from './Badges.module.scss';
export interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  type: BadgeTypes;
  label: string;
  startIcon?: IconNames;
  endIcon?: IconNames;
  size?: BadgeSize;
  data_cy?: string;
  className?: string;
}
const Badges: FC<BadgeProps> = ({
  type,
  startIcon,
  endIcon,
  size = 'medium',
  label,
  data_cy,
  className = '',
  ...props
}) => {
  return <div {...props} className={styles['badge-class'] + ' ' + `${type ? styles[`type-${type}`] : ''}` + ' ' + `${size ? styles[size] : ''}` + ' ' + className} data-cy={data_cy} data-sentry-component="Badges" data-sentry-source-file="Badges.tsx">
      {startIcon && <Icon type={'inherit'} name={startIcon} size={'small'} />}
      <span className={styles['label-container']}>{label}</span>
      {endIcon && <Icon type={'inherit'} name={endIcon} size={'small'} />}
    </div>;
};
export default Badges;